module.exports = __webpack_public_path__ + "img/mobile_stripes_graphics.45f2c538.png";